import axiosInstance from "./axiosInstance";
import type { components } from "./schema";

type Employee = components["schemas"]["Employee"];

export async function getEmployees(): Promise<Employee[]> {
  const { data } = await axiosInstance.get<unknown>("/employee");
  return Array.isArray(data) ? (data as Employee[]) : [];
}

export async function getEmployee(id: number): Promise<Employee | null> {
  const { data } = await axiosInstance.get<unknown>(`/employee/${id}`);
  return data && typeof data === "object" && !Array.isArray(data)
    ? (data as Employee)
    : null;
}
